import { render, staticRenderFns } from "./DepartmentDetails.vue?vue&type=template&id=264e1aa9"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports